// extracted by mini-css-extract-plugin
export default {"line":"quad-line-cell_line__OE6Ja","summary":"quad-line-cell_summary__m4uIZ","zero":"quad-line-cell_zero__1eyVs","placeHolderShimmer":"quad-line-cell_placeHolderShimmer__GU90s"};